import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../config/config';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadData } from '../Util/List/CustomList/loadData';
import Fetch from '../functions/Fetch';
import '../EntityProjects/EntityProjects.css';

function List() {
  const dispatch = useDispatch()
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const [years, setYears] = useState([])
  const [lastCompetency, setLastCompetency] = useState(null)

  const type_view = sessionSelector.employee_payment_portal_view

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getallemployeepayments',
    endpointGetAllYear: config.endpoints.backend + 'portal/getallyearemployeepayments'
  }

  useEffect(() => {
    const loadYears = async () => {
      const yearsResponse = await Fetch.post(paths.endpointGetAllYear, { friendly_url })

      setYears(yearsResponse.yearOptions)
      setLastCompetency(yearsResponse.lastCompetency)
    };

    loadYears();
  }, [])

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'year',
        type: 'select',
        label: 'Ano',
        options: years || [],
        validations: {
          required: true
        },
        columnSize: 3
      },
      {
        name: 'month',
        type: 'select',
        label: 'Mês',
        options: [{
          value: '01',
          label: 'Janeiro'
        },
        {
          value: '02',
          label: 'Fevereiro'
        },
        {
          value: '03',
          label: 'Março'
        },
        {
          value: '04',
          label: 'Abril'
        },
        {
          value: '05',
          label: 'Maio'
        },
        {
          value: '06',
          label: 'Junho'
        },
        {
          value: '07',
          label: 'Julho'
        },
        {
          value: '08',
          label: 'Agosto'
        },
        {
          value: '09',
          label: 'Setembro'
        },
        {
          value: '10',
          label: 'Outubro'
        },
        {
          value: '11',
          label: 'Novembro'
        },
        {
          value: '12',
          label: 'Dezembro'
        }],
        validations: {
          required: true
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      }
    ],
    values: {
      year: lastCompetency ? lastCompetency.year : null,
      month: lastCompetency ? lastCompetency.month : null
    }
  }

  let list = {
    labelTitle: 'Folha de Pagamento',
    icon: 'fa-receipt',
    filter: {
      friendly_url: friendly_url,
      last_competency: true,
      type_view: type_view
    },
    formFilters: filters,
    columns: [
      {
        name: type_view == 'EMPLOYEE' ? 'employee_name' : 'department_name',
        label: type_view == 'EMPLOYEE' ? 'Nome do Empregado' : 'Nome do Departamento',
        width: '20%'
      },
      {
        name: 'salary',
        label: 'Salário',
      },
      {
        name: 'fam_salary',
        label: 'Sal.Fam.',
      },
      {
        name: 'other_prov',
        label: 'Out.Prov.',
      },
      {
        name: 'inss',
        label: 'INSS',
      },
      {
        name: 'irrf',
        label: 'IRRF',
      },
      {
        name: 'other_desc',
        label: 'Out.Desc.',
      },
      {
        name: 'liquid_salary',
        label: 'Líquido',
      },
    ]
  };

  list = { ...list, ...paths };

  return (
    (years && lastCompetency) &&
    <div>
      <div className='pt-2 pl-3 pr-3'>
        <span style={{ marginLeft: '7.5px' }}>Folha de pagamento atualizada até: {lastCompetency.competency_date}</span>
      </div>
      <CustomListContainer
        canAdd={false}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
        icon={list.icon}
      />
    </div>
  );
}
export default List;
